module.exports = __webpack_public_path__ + "static/media/U.649a04bb.gif";